module.exports = __webpack_public_path__ + "img/activity.b648c0c4.png";